import React from "react";

/**
 * Anonymized dealer/group logos for social proof.
 * Pure SVG monograms — no external assets, no real names.
 */
const LOGOS = [
  { mono: "ND", name: "Nord Auto Gruppe" },
  { mono: "M+", name: "München Plus Mobility" },
  { mono: "RP", name: "Rheinland Premium" },
  { mono: "SX", name: "Süd-Express GW" },
  { mono: "BW", name: "Baden Werk Auto" },
  { mono: "AG", name: "Alpen Gruppe" },
  { mono: "EM", name: "Elbe Motor" },
  { mono: "HG", name: "Hanse Garage" },
];

export default function LogoBar() {
  return (
    <section
      data-testid="logo-bar"
      aria-label="Auswahl unserer Service-Partner und Händler"
      className="relative overflow-hidden border-b border-slate-200 bg-slate-50/50 py-14 dark:border-cyan-950/70 dark:bg-[#09111a]/80"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <p className="label-mono text-slate-500 dark:text-slate-500">Vertrauen aus dem DACH-Raum</p>
            <h2 className="mt-2 font-display text-xl sm:text-2xl font-semibold text-slate-900 tracking-tight dark:text-slate-50">
              Im Einsatz bei 34 Händlern und Händlergruppen.
            </h2>
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 dark:text-slate-500">
            Logos auf Wunsch anonymisiert
          </p>
        </div>
      </div>

      {/* Full-width marquee */}
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-slate-50 to-transparent dark:from-[#09111a]" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-slate-50 to-transparent dark:from-[#09111a]" />
        <div className="logo-marquee flex gap-4 px-4">
          {[...LOGOS, ...LOGOS].map((l, i) => (
            <LogoTile key={i} mono={l.mono} name={l.name} aria-hidden={i >= LOGOS.length} />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes logoScroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .logo-marquee {
          width: max-content;
          animation: logoScroll 38s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .logo-marquee { animation: none; }
        }
      `}</style>
    </section>
  );
}

function LogoTile({ mono, name }) {
  return (
    <div
      title={name}
      className="shrink-0 flex min-w-[220px] items-center gap-3 rounded-lg border border-slate-200 bg-white px-5 py-3.5 transition-colors hover:border-slate-300 dark:border-cyan-950/70 dark:bg-[#0b121c] dark:hover:border-cyan-700/40"
    >
      <span className="relative inline-flex size-9 shrink-0 items-center justify-center rounded-md bg-slate-900 text-white dark:bg-[#0d1823]">
        <span className="absolute inset-0 rounded-md gradient-accent opacity-70" />
        <span className="relative font-display font-bold text-[13px] tracking-tight">{mono}</span>
      </span>
      <div className="min-w-0">
        <p className="truncate font-display text-[15px] font-semibold tracking-tight text-slate-900 dark:text-slate-50">
          {name}
        </p>
        <p className="mt-0.5 label-mono text-[10px] text-slate-400 dark:text-slate-500">Live · seit 2024</p>
      </div>
    </div>
  );
}
